import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const PieChart = ({ data, options, styleName }) => {
  return (
    <div
      className={`${styleName}`}
      // style={{height:"220px"}}
    >
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
